import { createContext, useContext } from 'react';

const SidebarContext = createContext({
  toggleMenuItem: () => {},
  activeMenuItem: null,
});

const useSidebarContext = () => useContext(SidebarContext);
export { SidebarContext, useSidebarContext };
